<template>
  <div class="price-lpu-back align-self-start">
    <v-btn
      v-if="!isMobile"
      :href="lpuHref"
      depressed
      height="52"
      class="branding-btn branding-btn--white rounded-20 text-none text-body-1 elevation-1"
      data-qa="lpu_page_price_back"
    >
      <span
        class="ui-icon-arrow-back mr-2"
        aria-hidden="true"
      />
      {{ tStatic('Описание клиники') }}
    </v-btn>
    <a
      v-else
      class="text-body-1 primary--text d-flex align-center text-decoration-none"
      :href="lpuHref"
      data-qa="lpu_page_price_back"
    >
      <span
        class="ui-icon-arrow-back mr-2"
        aria-hidden="true"
      />
      <span>{{ tStatic('О клинике') }}</span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import useURLStore from 'src/store/useURLStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

const props = defineProps<{
  lpu: Lpu
}>()

const isMobile = useIsMobile()
const { reverseFull } = useURLStore()
const lpuHref = reverseFull({
  name: 'lpu',
  args: [
    props.lpu.town.translit,
    props.lpu.translit,
  ],
})
</script>
